import { Badge, Flex, Text } from '@chakra-ui/react'

import { FormModal } from '../../../../components/FormModal'

interface IPromoBannerCoursesModalProps {
  isOpen: boolean
  onClose: () => void
  bannerText?: string
  courses?: Array<{ id: number; name: string }>
}

export default function PromoBannerCoursesModal({
  isOpen,
  onClose,
  bannerText,
  courses
}: IPromoBannerCoursesModalProps) {
  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <>
          Cursos vinculados
          {bannerText && (
            <Text variant="caption" as="span" ml={2}>
              — {bannerText}
            </Text>
          )}
        </>
      }
      size="compact"
    >
      {!courses?.length ? (
        <Text variant="caption">Nenhum curso vinculado.</Text>
      ) : (
        <Flex gap={2} flexWrap="wrap">
          {courses.map((course) => (
            <Badge key={course.id} colorScheme="blue" variant="subtle" py={1}>
              {course.name}
            </Badge>
          ))}
        </Flex>
      )}
    </FormModal>
  )
}
